import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-shiping",
  "use": "icon-shiping-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-shiping\">\r\n<path d=\"M445.528 674.616c-6.971 0-13.983-1.603-20.523-4.855-15.724-7.821-25.491-23.59-25.491-41.151V395.391c0-17.562 9.768-33.33 25.492-41.152 15.232-7.577 33.04-6.197 46.871 3.527L658.24 474.547l1.051 0.795c11.589 8.766 18.235 22.127 18.235 36.658 0 14.53-6.647 27.892-18.236 36.656l-1.051 0.795-186.363 116.783c-7.893 5.55-17.083 8.382-26.348 8.382z m13.986-253.79v182.348L605.012 512l-145.498-91.174z\" p-id=\"1689\" /><path d=\"M803.6 873.502H220.4c-65.286 0-118.4-53.114-118.4-118.4V268.898c0-65.286 53.114-118.4 118.4-118.4h583.2c65.286 0 118.4 53.114 118.4 118.4v486.203c0 65.287-53.114 118.401-118.4 118.401zM220.4 210.498c-32.202 0-58.4 26.198-58.4 58.4v486.203c0 32.202 26.198 58.4 58.4 58.4h583.2c32.202 0 58.4-26.198 58.4-58.4V268.898c0-32.202-26.198-58.4-58.4-58.4H220.4z\" p-id=\"1690\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/shiping.svg
// module id = V1g7
// module chunks = 67